const typeMap = [
    {
        validator: 'visa',
        vault: 'Visa',
        gps: 'VISA'
    },
    {
        validator: 'american-express',
        vault: 'AmericanExpress',
        gps: 'AMERICAN_EXPRESS'
    },
    {
        validator: 'diners-club',
        vault: 'Diners',
        gps: 'DINERS'
    },
    {
        validator: 'jcb',
        vault: 'JCB',
        gps: 'JCB'
    },
    {
        validator: 'unionpay',
        vault: 'UnionPay',
        gps: 'UNION_PAY'
    },
    {
        validator: 'maestro',
        vault: 'Maestro',
        gps: 'MAESTRO'
    },
    {
        validator: 'mastercard',
        vault: 'Mastercard',
        gps: 'MASTERCARD'
    },
    {
        validator: 'discover',
        vault: 'Discover',
        gps: 'DISCOVER'
    }
]

function mapCardType({ value, from, to }) {
    var type = typeMap.find((card) => card[from] === value)
    return type ? type[to] : undefined
}

export function validatorToGPS(value) {
    return mapCardType({
        value: value,
        from: 'validator',
        to: 'gps'
    })
}

export function GPStoValidator(value) {
    return mapCardType({
        value: value,
        from: 'gps',
        to: 'validator'
    })
}

export function validatorToVault(value) {
    return mapCardType({
        value: value,
        from: 'validator',
        to: 'vault'
    })
}

export function vaultToValidator(value) {
    return mapCardType({
        value: value,
        from: 'vault',
        to: 'validator'
    })
}
